/*
 * From http://www.redblobgames.com/maps/mapgen2/
 * Copyright 2017 Red Blob Games <redblobgames@gmail.com>
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *      http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
'use strict';

const SimplexNoise = require('simplex-noise');
const Poisson =      require('poisson-disk-sampling');
const DualMesh =     require('@redblobgames/dual-mesh');
const MeshBuilder =  require('@redblobgames/dual-mesh/create');
const Map =          require('@redblobgames/mapgen2');
const DrawWater =    require('./draw-water');
const Lighting =     require('./lighting');
const {makeRandInt, makeRandFloat} = require('@redblobgames/prng');


let param = {
    seed: 187,
    variant: 0,
    spacing: 5,
    temperature: 0,
    rainfall: 0,
    canvasSize: 1000,
};

(function readSeedFromUrl() {
    let match = (window.location.search || "").match(/\?seed=([0-9]+)/);
    if (match) {
        param.seed = parseFloat(match[1]) | 0;
    }
})();

let canvas = document.createElement('canvas');
canvas.width = canvas.height = param.canvasSize;

function draw() {
    console.time('mesh-init');
    let builder = new MeshBuilder({boundarySpacing: param.spacing})
        .addPoisson(Poisson, param.spacing, makeRandFloat(12345))
        .create();
    let mesh = new DualMesh(builder);
    console.timeEnd('mesh-init');
    
    console.time('map-init');
    let map = new Map(mesh, {amplitude: 0.2, length: 100, seed: 12345}, makeRandInt);
    console.timeEnd('map-init');
    
    let ctx = canvas.getContext('2d');

    console.log(`triangles = ${mesh.numTriangles} regions = ${mesh.numRegions}`);
    
    console.time('map-gen');
    map.calculate({
        noise: new SimplexNoise(makeRandFloat(param.seed)),
        numRivers: 100,
        drainageSeed: param.variant,
        riverSeed: param.variant,
        biomeBias: {temperature: param.temperature, moisture: param.rainfall},
    });
    console.timeEnd('map-gen');

    ctx.save();
    ctx.scale(canvas.width / 1000, canvas.height / 1000);
    ctx.clearRect(0, 0, 1000, 1000);
    
    console.time('draw-lakes');
    DrawWater.lakes(ctx, map);
    console.timeEnd('draw-lakes');
    
    console.time('draw-rivers');
    DrawWater.rivers(ctx, map);
    console.timeEnd('draw-rivers');

    ctx.restore();
    
    Lighting.draw(map, canvas);
}


draw();

// Ugh this is yet another hack… but since ACOM is cancelled it's not
// worth cleaning up all this code.
let button = document.getElementById('button-export');
button.addEventListener('change', () => {
    if (button.checked) {
        Lighting.datGUI.close();
    } else {
        Lighting.datGUI.open();
    }
    setTimeout(draw, 20);
});
